import { render, staticRenderFns } from "./Erp6SaleShip.vue?vue&type=template&id=1ed27666&scoped=true&"
import script from "./Erp6SaleShip.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleShip.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleShip.vue?vue&type=style&index=0&id=1ed27666&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed27666",
  null
  
)

export default component.exports